import * as yup from 'yup';
import { UpdateClientProfileRequest } from '../happypaws-shared/src/User/models/UpdateClientProfileRequest';

export const personalInfoSchema: yup.ObjectSchema<
  Pick<
    UpdateClientProfileRequest,
    'firstName' | 'lastName' | 'phone' | 'photoUrl' | 'city' | 'country' | 'postalCode'
  >
> = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  phone: yup.string().nullable().optional(),
  photoUrl: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
});

export const aboutMeSchema: yup.ObjectSchema<Pick<UpdateClientProfileRequest, 'bio'>> = yup.object({
  bio: yup.string().nullable().optional(),
});

export const emergencyContactSchema: yup.ObjectSchema<
  Pick<
    UpdateClientProfileRequest,
    'emergencyContactName' | 'emergencyContactRelationship' | 'emergencyContactPhone'
  >
> = yup.object({
  emergencyContactName: yup.string().nullable().optional(),
  emergencyContactRelationship: yup.string().nullable().optional(),
  emergencyContactPhone: yup.string().nullable().optional(),
});
